module.exports = __webpack_public_path__ + "img/wallet.0f1a5cfc.svg";